var React = require('react');

function UiPlus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M29.7,14.8c0,1.4-1.1,2.5-2.5,2.5h-9.7v9.7c0,1.4-1.1,2.5-2.6,2.5s-2.6-1.1-2.6-2.5v-9.7H2.6\n\t\t\tc-1.4,0-2.6-1.1-2.6-2.5s1.1-2.6,2.6-2.6h9.7V2.5c0-1.4,1.1-2.5,2.6-2.5c1.4,0,2.5,1.1,2.5,2.5l0,0v9.7h9.7\n\t\t\tC28.5,12.3,29.7,13.4,29.7,14.8z"})))]);
}

UiPlus.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 29.7 29.6","style":{"enableBackground":"new 0 0 29.7 29.6"},"xmlSpace":"preserve"};

module.exports = UiPlus;

UiPlus.default = UiPlus;
